import styled from "styled-components";
import { Button as MuiButton } from "@mui/material";

const getGridColumns = (length) => {
  if (length <= 3) return length;
  return 3;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: var(--mui-palette-background-default);
  box-sizing: border-box;
  overflow: hidden;
`;

export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--mui-palette-background-paper);
  box-shadow: var(--mui-shadows-2);
  overflow: hidden;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--mui-palette-divider);
  background-color: var(--mui-palette-background-paper);
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 22px;
  color: #111;
  margin-bottom: 0;
`;

export const ButtonBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding-block: 12px;
`;

export const CustomButton = styled(MuiButton)(({ theme }) => ({
  "&.Mui-disabled": {
    backgroundColor: "var(--mui-palette-action-disabledBackground)",
    color: "var(--mui-palette-action-disabled)",
  },
}));

export const GridContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 1.5rem;
  flex: 1;
  overflow: hidden;
  padding: 0 16px 16px;
  .ag-theme-material,
  .ag-theme-quartz {
    --ag-material-primary-color: var(--mui-palette-primary-main);
    --ag-background-color: var(--mui-palette-background-paper);
    --ag-odd-row-background-color: var(--mui-palette-action-hover);
    --ag-header-background-color: var(--mui-palette-background-default);
    --ag-border-color: var(--mui-palette-divider);
    --ag-row-hover-color: var(--mui-palette-action-hover);
    border-radius: 4px;
    overflow: hidden;
    height: 100%;
    .ag-cell-inline-editing {
      height: 100% !important;
      overflow: hidden !important;
      padding: 0 !important;
    }
    .ag-cell-edit-input {
      height: 100% !important;
      width: 100% !important;
      padding: 0 10px !important;
      box-sizing: border-box !important;
      margin: 0 !important;
      border: none !important;
    }
    .ag-cell {
      display: flex;
      align-items: center;
    }
    .ag-row {
      height: 48px !important;
    }
    .ag-header-cell {
      font-weight: 600;
    }
  }

  .inner-col {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`;

export const HeaderContainerInner = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
`;
